import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    path: [],
    isBack: false,
    certificateInfo: null,
  },
  getters: {
    /**
     * 前の画面pathを取得
     * @param {*} state
     */
    getPrevPath(state) {
      return state.path[0];
    },
    /**
     * 前の画面に戻る状態フラグ取得
     * @param {*} state
     */
    getIsBack(state) {
      return state.isBack;
    },
    /**
     * 証明書情報を取得
     * @param {*} state
     */
    getCertificateInfo(state) {
      return state.certificateInfo;
    },
  },
  mutations: {
    /**
     * 前の画面pathをセットする
     * @param {*} state
     * @param {*} payload
     */
    setPrevPath(state, payload) {
      state.path.unshift(payload.prevPath);
    },
    /**
     * pathの履歴の先頭を削除
     * 前の画面に戻るとき用
     * @param {*} state
     */
    shiftPath(state) {
      state.path.shift();
    },
    /**
     * pathの履歴をリセットする
     * @param {*} state
     */
    resetPath(state) {
      state.path = [];
    },
    /**
     * 前の画面に戻る状態フラグをセットする
     * @param {*} state
     * @param {*} payload
     */
    setIsBack(state, payload) {
      state.isBack = payload;
    },
    /**
     * 証明書情報をセット
     * @param {*} state
     * @param {*} payload
     */
    setCertificateInfo(state, payload) {
      state.certificateInfo = payload.certificateInfo;
    },
  },
  actions: {

  },
});
